<template>
	<div class="container is-fluid">
      <div class="columns" v-show="page === 1">

            <div class="column ">
             
                  <h2 class="title">Update Details</h2>
                 <div class="field">
                  <label class="label">Garment Description</label>
                  <div class="select is-fullwidth">
                  <select>
                    <option>Select garment</option>
                    <option>Liam 64 HZ Top</option>
                     <option>Aston Skinny Squad Pant</option>
                  </select>
                </div>
                </div>

                 <div class="field">
                  <label class="label">Colour</label>
                  <div class="control">
                    <input class="input" type="text" placeholder="Black/White, Multi etc.">
                  </div>
                </div>

                <div class="field is-grouped">
                <div class="control">
                  <button class="button is-link" @click="page = 2">Next</button>
                </div>
                <div class="control">
                  <button class="button is-link is-light">Back</button>
                </div>
              </div>
            </div>

            <div class="column is-two-thirds">
              <img src="@/assets/images/DIGI75282.jpg" />
            </div>

            
            
      </div>

      <div class="columns" v-show="page === 2">

            <div class="column ">
             
                  <h2 class="title">Update Details</h2>
                 <div class="field">
                  <label class="label">Garment Description</label>
                  <div class="select is-fullwidth">
                  <select>
                    <option>Select garment</option>
                    <option>Liam 64 HZ Top</option>
                     <option>Aston Skinny Squad Pant</option>
                  </select>
                </div>
                </div>

                 <div class="field">
                  <label class="label">Colour</label>
                  <div class="control">
                    <input class="input" type="text" placeholder="Black/White, Multi etc.">
                  </div>
                </div>

                <div class="field is-grouped">
                <div class="control">
                  <button class="button is-link" @click="page = 3">Next</button>
                </div>
                <div class="control">
                  <button class="button is-link is-light">Back</button>
                </div>
              </div>
            </div>

            <div class="column is-two-thirds">
              <img src="@/assets/images/DIGI83866.png" />
            </div>

            
            
      </div>

      <div class="columns" v-show="page === 3">
          <div class="notification is-primary">
         All orders are up to date with garment and colour selected or entered.
        </div>
        </div>
	</div>
</template>	

<script>
export default {
  
  data: function () {
    return {
      page : 1
    }
  }
}
</script>